import React, { FunctionComponent } from 'react';

import styles from './Proposition.scss';

export interface PropositionProps {
  className?: string;
  children?: React.ReactNode;
  message: string;
}

export const Proposition: FunctionComponent<PropositionProps> = ({
  className,
  children,
  message,
}) => (
  <div className={`${styles.Proposition} ${className}`} data-qa="proposition">
    <div className={styles.Content}>
      {children ? <div className={styles.Icon}>{children}</div> : null}
      <div className={`${styles.Message} jg-text--light`}>{message}</div>
    </div>
  </div>
);
